import { render, staticRenderFns } from "./batchrefund.vue?vue&type=template&id=2df83318&scoped=true&"
import script from "./batchrefund.vue?vue&type=script&lang=js&"
export * from "./batchrefund.vue?vue&type=script&lang=js&"
import style0 from "./batchrefund.vue?vue&type=style&index=0&id=2df83318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df83318",
  null
  
)

export default component.exports